import { ChangeEvent, Dispatch, SetStateAction, useRef } from "react";
import { CustomInput } from "@/common/inputs";
import { LightText } from "@/common/texts";
import { CustomField } from "@/model";

const InputFareHarbor: React.FC<{
  handleChangeSchedule?: (
    e: ChangeEvent<HTMLInputElement>,
    i: number,
    field: CustomField,
  ) => void;
  handleChangeTariff?: (
    e: ChangeEvent<HTMLInputElement>,
    i: number,
    field: CustomField,
    customFields: string | number,
    j: number,
  ) => void;
  i: number;
  j?: number;
  customFields?: string | number;
  field: CustomField;
  value: string;
  setRequiredMissingScheduledFields?: Dispatch<SetStateAction<number>>;
  setRequiredMissingTariffFields?: Dispatch<SetStateAction<number>>;
}> = ({
  handleChangeSchedule,
  handleChangeTariff,
  i,
  field,
  j,
  customFields,
  value,
  setRequiredMissingScheduledFields,
  setRequiredMissingTariffFields,
}) => {
  const isUpdated = useRef(false);

  const sumMissingField = () => {
    if (setRequiredMissingScheduledFields) {
      setRequiredMissingScheduledFields((prevState) => prevState + 1);
    }
    if (setRequiredMissingTariffFields) {
      setRequiredMissingTariffFields((prevState) => prevState + 1);
    }
  };

  const subMissingField = () => {
    if (setRequiredMissingScheduledFields) {
      setRequiredMissingScheduledFields((prevState) => prevState - 1);
    }
    if (setRequiredMissingTariffFields) {
      setRequiredMissingTariffFields((prevState) => prevState - 1);
    }
  };

  const handleUpdateFields = (e: ChangeEvent<HTMLInputElement>) => {
    if (field.isRequired) {
      //TO DO
      if (isUpdated.current) {
        if (value.length > 0 && e.target.value.length == 0) {
          sumMissingField();
        }
        if (value.length == 0 && e.target.value.length > 0) {
          subMissingField();
        }
      } else {
        if (e.target.value.length > 0) {
          subMissingField();
        } else {
          sumMissingField;
        }
        isUpdated.current = true;
      }
    }
  };
  return (
    <>
      {field.description && (
        <LightText style={{ marginBottom: "10px" }}>
          {field.description}
        </LightText>
      )}
      <CustomInput
        style={{ width: "245px" }}
        onChange={(e) => {
          handleUpdateFields(e);
          handleChangeSchedule ? handleChangeSchedule(e, i, field)
          : handleChangeTariff ?
            handleChangeTariff(e, i, field, customFields ?? "", j ?? 0)
          : null;
        }}
      />
    </>
  );
};

export default InputFareHarbor;
